import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { ConfirmProvider } from './contexts/ConfirmContext';
import { ThemeProvider } from './contexts/ThemeContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Cases from './pages/Cases';
import CreateCase from './pages/CreateCase';
import CaseDetail from './pages/CaseDetail';
import EditCase from './pages/EditCase';
import Users from './pages/Users';
import Profile from './pages/Profile';
import FirstLoginSetup from './pages/FirstLoginSetup';
import Scraper from './pages/Scraper';
import MergeCase from './pages/MergeCase';

const queryClient = new QueryClient();

function App() {
  return (
    <ThemeProvider>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
      <ConfirmProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/setup"
              element={
                <PrivateRoute>
                  <FirstLoginSetup />
                </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="cases" element={<Cases />} />
              <Route path="cases/new" element={<CreateCase />} />
              <Route path="cases/:id" element={<CaseDetail />} />
              <Route path="cases/:id/edit" element={<EditCase />} />
              <Route path="users" element={<Users />} />
              <Route path="scraper" element={<Scraper />} />
              <Route path="merge/:matchId" element={<MergeCase />} />

              <Route path="profile" element={<Profile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
      </ConfirmProvider>
      </ToastProvider>
    </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
